import { nextTick } from "vue";

const tableUtils = {

  /**
   * 結果一覧保持テーブルを取得
   * @returns 
   */
  getSearchResultTable(elm: HTMLElement = document.body): HTMLTableElement | null {
    return elm.querySelector(".resizable-table table");
  },

  /**
   * 列幅を要素に合わせて自動調整する。 \
   * 調整後に手動でのリサイズを可能にするため、列幅の保持とtable-layoutの編集を行う。
   * @param _table 調整対象のHTMLTableElement
   */
  async adjustColumnWidth(table: HTMLTableElement) {
    const thList = table.querySelectorAll("th");

    // widthリセット + table-layoutをautoにすることで列幅を自動調整
    thList.forEach(e => e.style.width = '');
    table.style.width = '';
    table.style.tableLayout = "auto";

    // 描画を待つ
    await nextTick();

    // 自動調整後の列幅を保持 + table-layoutをfixedにすることで手動でのリサイズを可能にする。
    thList.forEach(e => e.style.width = e.getBoundingClientRect().width + "px");
    table.style.width = table.getBoundingClientRect().width + "px";
    table.style.tableLayout = "fixed";
  },

  /**
   * 列幅の手動リサイズ処理
   * @param e リサイズハンドルのMouseDown時のイベント
   */
  resizeColumnWidth(e: MouseEvent) {

    const resizeHandle = e.target as HTMLElement;
    const table = resizeHandle.closest("table") as HTMLTableElement;
    const header = resizeHandle.closest("th") as HTMLElement;

    const startHeaderWidth = header.getBoundingClientRect().width;
    const startTableWidth = table.getBoundingClientRect().width;
    const startX = e.clientX;

    // 移動量を対象の列幅と、テーブル全体の幅に加算
    const move = (e: MouseEvent) => {
      const diff = e.clientX - startX;
      table.style.width = (startTableWidth + diff) + "px";
      header.style.width = (startHeaderWidth + diff) + "px";
    }

    // ドラッグ終了時にイベントを削除
    const up = (e: MouseEvent) => {
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mouseup", up);
    }

    document.addEventListener("mousemove", move);
    document.addEventListener("mouseup", up);
  },
}

export default tableUtils;